import { useState } from 'react'
import Formsy from 'formsy-react'
import { resetPassword } from 'login-and-signup/actions'
import { authStateSelector } from 'login-and-signup/selectors'
import { pendingSelector } from 'api/selectors'
import Button from 'shared/components/Button'
import FormsyInput from 'shared/components/Textfield/withFormsy'

const ForgotPasswordForm = ({ auth, pending, translate: t, resetPassword }) => {
    const [formValues, setFormValues] = useState({
        email: '',
        canSubmit: false,
    })

    const onChangeHandler = event => {
        const { value, name } = event.target

        setFormValues({
            ...formValues,
            [name]: value,
        })
    }

    const enableSubmit = () => {
        setFormValues({
            ...formValues,
            canSubmit: true,
        })
    }

    const disableSubmit = () => {
        setFormValues({
            ...formValues,
            canSubmit: false,
        })
    }
    const submit = () => {
        resetPassword(formValues.email)
    }

    return (
        <div className="container">
            {auth.isPasswordResetEmailSent ? (
                <div className="container text-center">
                    <p>
                        <T>auth.forgot.pass.email.conf</T> <b>{formValues.email}</b>
                    </p>
                </div>
            ) : (
                <Formsy
                    className="header-form forgot-password-form"
                    onSubmit={submit}
                    onValid={enableSubmit}
                    onInvalid={disableSubmit}>
                    <legend>
                        <T>auth.forgot.pass.title</T>
                    </legend>
                    <p style={{ fontSize: '.75rem' }}>
                        <T>auth.forgot.pass.email.label</T>
                    </p>
                    <FormsyInput
                        placeholder={t('auth.email.label')}
                        name="email"
                        type="email"
                        onChange={onChangeHandler}
                        validations="isEmail"
                        validationError={t('auth.forgot.pass.email.error')}
                        required
                    />
                    <Button
                        className="mt-2"
                        size="large"
                        block
                        type="submit"
                        isLoading={pending.resetPassword === true}
                        disabled={!formValues.canSubmit}>
                        <T>auth.forgot.pass.submit</T>
                    </Button>
                </Formsy>
            )}
        </div>
    )
}

const mapStateToProps = createStructuredSelector({
    auth: authStateSelector,
    pending: pendingSelector,
})

export default compose(
    withTranslate,
    connect(mapStateToProps, {
        resetPassword,
    })
)(ForgotPasswordForm)
